import { db } from "../../../firebase";
import { collection, addDoc, doc } from "firebase/firestore";
import { toast } from "react-hot-toast";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../../firebase";

export const addNewProperty = async (
  data,
  filteredFinancials,
  terms,
  filteredRenewalFees,
  filteredPropGroups,
  filteredAccounts,
  filteredMRT,
  filteredRT,
  filteredLT,
  filteredNotes,
  companyName,
  files,
  navigate
) => {
  try {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const propertyRef = collection(companyDocRef, "properties");


    Object.keys(data).forEach((field) => {
      if (data[field] === undefined) {
        data[field] = "";
      }
    });

    const propertyNameAddress = {
      propertyType: data.propertyType,
      propertyName: data.propertyName,
      addressLine1: data.propertyAddressOne,
      addressLine2: data.propertyAddressTwo,
      city: data.city,
      state: data.state,
      zipCode: data.zipCode,
      country: data.country,
      affordableHousingProperty: data.affordableHousingProperty,
    };
    const propertyInformation = {
      status: data.status ? data.status : "",
      isRentReady: data.rentReady ? data.rentReady : "",
      readyForShowingOn: data.showingOn
        ? data.showingOn.format("YYYY-MM-DD")
        : "",
      description: data.description,
      portfolio: data.portfolio,
      siteManagerTitle: data.managerSalutation,
      siteManagerFirstName: data.managerFirstName,
      siteManagerLastName: data.managerLastName,
      managerPhoneNumber: data.managerPhoneNumber,
      yearBuilt: data.yearBuilt,
      managementStartDate: data.managementStartDate
        ? data.managementStartDate.format("YYYY-MM-DD")
        : "",
      liabilityLandlordInsurance: data.liabilitytoLandlordInsurance
        ? data.liabilitytoLandlordInsurance
        : "",
      policyAdditionalInterest: data.policyAdditionalInterest
        ? data.policyAdditionalInterest
        : "",
      contactEmail: data.contactEmail ? data.contactEmail : "",
      // tags: [...data.tags],
    };
    const rentalInformation = {
      bedrooms: data.bedrooms ? data.bedrooms : "",
      bathrooms: data.bathrooms ? data.bathrooms : "",
      squareFeet: data.squareFeet ? data.squareFeet : "",
      marketRent: data.marketRent ? data.marketRent : "",
      isUseMarketRentOnAds: data.marketRentOnAds ? data.marketRentOnAds : "",
      advertisedRent: data.advertisedRent ? data.advertisedRent : "",
      applicationFee: data.applicationFee ? data.applicationFee : "",
      securityDeposit: data.securityDeposit ? data.securityDeposit : "",
      NSFFee: data.NSFFee,
      isUseCustomInspectionDate: data.useCustomInspectionDate
        ? data.useCustomInspectionDate
        : "",
      lastInspectionOn: data.lastInspectionOn
        ? data.lastInspectionOn.format("YYYY-MM-DD")
        : "",
      rentStatus: data.RentStatus ? data.RentStatus : "",
      legalRent: data.legalRent ? data.legalRent : "",
      preferentialRent: data.preferentialRent ? data.preferentialRent : "",
      utilitiesIncludedInLease: data.leaseUtilities
        ? [...data.leaseUtilities]
        : "",
      appliancesIncludedInLease: data.leaseAppliances
        ? [...data.leaseAppliances]
        : "",
      additionalLeaseInformation: data.additionalLeaseInformation
        ? data.additionalLeaseInformation
        : "",
    };
    const nonRevenueStatus = {
      nonRevenueUnit: data.nonRevenueUnit ? data.nonRevenueUnit : "",
      nonRevenueType: data.nonRevenueType ? data.nonRevenueType : "",
      nonRevenueStart: data.nonRevenueStart
        ? data.nonRevenueStart.format("YYYY-MM-DD")
        : "",
    };
    const amenities = {
      catsAllowed: data.catsAllowed,
      dogsAllowed: data.dogsAllowed,
      amenities: [...data.amenities],
    };
    const managementFees = {
      id: "",
      managementFeeStartDate: data.managementFeeStartDate
        ? data.managementFeeStartDate.format("YYYY-MM-DD")
        : "",
      waiveFeeWhenVacant: data.waiveFee,
      feeType: data.feeType,
      managementFee: data.amount,
      minManagementFee: data.minimumFee ? data.minimumFee : "",
      maxManagementFee: data.maximumFee ? data.maximumFee : "",
    };

    const maintenanceInformation = {
      maintenanceLimit: data.maintenanceLimit,
      insuranceExpiration: data.insuranceExpiration
        ? data.insuranceExpiration.format("YYYY-MM-DD")
        : "",
      isItCoveredByHome: data.homeWarranty,
      homeWarrantyCompany: data.homeWarrantyCompany
        ? data.homeWarrantyCompany
        : "",
      homeWarrantyExpiration: data.homeWarrantyExpiration
        ? data.homeWarrantyExpiration.format("YYYY-MM-DD")
        : "",
      policyNumber: data.policyNumber ? data.policyNumber : "",
      contactNumber: data.contactNumber ? data.contactNumber : "",
      unitPreEntryAuthorized: data.preAuthorized,
      maintenanceNotes: data.maintenanceNotes,
      maintenanceInstructions: data.maintenanceInstructions,
    };
    const leaseSettings = {
      leaseGenerationDefaultMethod: data.leaseGenerationMethod,
      sayEagleTemplates: {
        defaultLeaseTemplates: {
          leaseTemplate: data.leaseTemplate ? data.leaseTemplate : "",
          addendaTemplates: data.addendaTemplates
            ? [...data.addendaTemplates]
            : "",
          leaseAttachments: data.leaseAttachments
            ? [...data.leaseAttachments]
            : "",
        },
        defaultRenewalTemplates: {
          renewalTemplate: data.SayeagleRenewalTemplate
            ? data.SayeagleRenewalTemplate
            : "",
          addendaTemplates: data.renewalAddendaTemplates
            ? [...data.renewalAddendaTemplates]
            : "",
          renewalAttachments: data.renewalAttachments
            ? [...data.renewalAttachments]
            : "",
        },
        defaultRenewalMTMTemplates: {
          mTMRenewalTemplate: data.mTMRenewalTemplate
            ? data.mTMRenewalTemplate
            : "",
          addendaTemplates: data.mTMRenewaladdendaTemplates
            ? [...data.mTMRenewaladdendaTemplates]
            : "",
          mTmRenewalAttachments: data.mTmRenewalAttachments
            ? [...data.mTmRenewalAttachments]
            : "",
        },
      },
      pdfFormTemplates: {
        defaultLeaseTemplates: filteredLT,
        defaultRenewalTemplates: filteredRT,
        defaultRenewalMTMTemplates: filteredMRT,
      },

      defaultRenewalSettings: {
        template: data.template,
        changeRentBy: data.changeRentBy,
        renewalOptions: terms,
      },
    };
    const LateFeePolicy = {
      lateFeeType: data.lateFeeType,
      baseLateFeeFlat: data.baseLateFeeFlat ? data.baseLateFeeFlat : "",
      baseLateFeePercent: data.baseLateFeePercent
        ? data.baseLateFeePercent
        : "",
      eligibleCharges: data.eligibleCharges,
      gracePeriod: data.gracePeriod,
      gracePeriodAfterDays: data.gracePeriodAfterDays
        ? data.gracePeriodAfterDays
        : "",
      gracePeriodOnDay: data.gracePeriodOnDay ? data.gracePeriodOnDay : "",
      chargeDailyLateFee: data.chargeDailyLateFee,
      dailyLateFee: data.dailyLateFee ? data.dailyLateFee : "",
      maxDailyLateFee: data.maxDailyLateFee ? data.maxDailyLateFee : "",
      graceBalance: data.graceBalance,
      percentFrom: data.percentFrom ? data.percentFrom : "",
      partialPayments: data.partialPayments ? data.partialPayments : "",
    };
    const ownerAndFinancials = {
      owners: filteredFinancials,
      paymentType: data.paymentType,
      paymentAmount: data.paymentAmount ? data.paymentAmount : "",
      reservedFunds: data.reservedFunds,
      vendor1099: data.vendor1099,
      fiscalYearEnd: data.fiscalYearEnd,
      basisForOwnerPackets: data.basisForOwnerPackets,
    };
    const additionalFees = {
      leaseFee: {
        leaseFeeType: data.leaseFeeType,
        leaseFee: data.leaseFee,
      },
      renewalFee: {
        renewalFeeType: data.renewalFeeType,
        renewalFee: data.renewalFee,
      },
      additionalFeeDetails: filteredRenewalFees,
    };

    function areAllFieldsEmpty(obj) {
      for (let key in obj) {
        if (
          obj.hasOwnProperty(key) &&
          obj[key] !== null &&
          obj[key] !== undefined &&
          obj[key] !== ""
        ) {
          return false; // If any non-empty field is found, return false
        }
      }
      return true; // All fields are empty
    }

    const allFieldsEmpty = areAllFieldsEmpty(managementFees);

    const uniqueIds = {}; // Helper object to keep track of seen ids
    const imagesUrl = []; // Helper object to keep track of seen ids
    const uniqueItems = files.filter((item) => {
      // If the id is not in the uniqueIds object, add it and return true
      if (!uniqueIds[item.uid]) {
        uniqueIds[item.uid] = true;
        return true;
      }
      // If the id is already in the uniqueIds object, return false to filter it out
      return false;
    });

    for (const file of uniqueItems) {
      const storageRef = ref(storage, `/files/properties/${file.name}`);
      const uploadTask = uploadBytesResumable(storageRef, file);

      try {
        await uploadTask;

        // File uploaded successfully
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        const fileData = {
          downloadURL: downloadURL,
          id: file.uid,
          name: file.name,
          type: file.type,
          isDefault: false,
        };
        imagesUrl.push(fileData);
        console.log("Download URL for", file.name, ":", downloadURL);
        // newFileList.push({ file, downloadURL });
      } catch (error) {
        console.error("Upload error for", file.name, ":", error);
      }
    }

    console.log("files", files);
    console.log("imagesUrlimagesUrlimagesUrl", imagesUrl);

    try {
      await addDoc(propertyRef, {
        propertyNameAddress,
        propertyInformation,
        rentalInformation,
        nonRevenueStatus,
        amenities,
        managementFees: allFieldsEmpty ? [] : [managementFees],
        maintenanceInformation,
        leaseSettings,
        LateFeePolicy,
        ownerAndFinancials,
        additionalFees,
        propertyGroups: filteredPropGroups,
        bankAccounts: filteredAccounts,
        notes: filteredNotes,
        attachments: imagesUrl ? imagesUrl : [],
      });
      navigate("/properties");

      toast.success("Property created successfully");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
